import Radium from 'radium';
import React from 'react';
import PropTypes from 'prop-types';

const Subcategories = props => (
  <ul style={styles.wrapper}>
    {props.children}
  </ul>
);

Subcategories.propTypes = {
  children: PropTypes.node
};

Subcategories.defaultProps = {
  children: null
};

const styles = {
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    padding: 0,
    listStyle: 'none'
  }
};

export default Radium(Subcategories);
